import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ChipSelectionChangeEvent {
  selected: boolean;
  id: number;
}

@Component({
  selector: 'ark-lib-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.css'],
})
export class ChipComponent {
  @Input() id!: number;
  @Input() iconUrl!: string;
  @Input() title!: string;
  @Input() selected: boolean = false;
  @Input() locked = false;
  @Input() showHash: boolean = false;

  @Output() chipClicked = new EventEmitter<ChipSelectionChangeEvent>();

  onClick() {
    if (this.locked) return;
    this.selected = !this.selected;

    this.chipClicked.emit({ id: this.id, selected: this.selected });
  }
}
